import axios from "../../../../helper/axios";
import * as actionTypes from "../../actionTypes";

export const setUserId = (userId) => {
  return {
    type: actionTypes.SET_USER_ID,
    userId,
  };
};

export const fetchUsersStart = () => {
  return {
    type: actionTypes.FETCH_USERS_START,
  };
};
export const fetchUsersFail = (error) => {
  return {
    type: actionTypes.FETCH_USERS_FAIL,
    error,
  };
};
export const fetchUsersSuccess = (users, count) => {
  return {
    type: actionTypes.FETCH_USERS_SUCCESS,
    users,
    count,
  };
};

export const fetchUsers = (pageN, pageS) => {
  return (dispatch) => {
    // console.log(pageN + ' ' + pageS);
    dispatch(fetchUsersStart());
    axios
      .get(`admin/clients?pageNumber=${pageN}&pageSize=${pageS}`)
      .then((res) => {
        // console.log(res.data.clients);
        // console.log(res.data.clients, res.data.clients.length);
        dispatch(fetchUsersSuccess(res.data.clients, res.data.total));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(fetchUsersFail(err.response.data.message));
        } else {
          dispatch(fetchUsersFail("Something went wrong"));
        }
      });
  };
};

// Create Account
export const createClientStart = () => {
  return {
    type: actionTypes.CREATE_CLIENT_START,
  };
};
export const createClientFail = (error) => {
  return {
    type: actionTypes.CREATE_CLIENT_FAIL,
    error,
  };
};
export const createClientSuccess = (msg) => {
  return {
    type: actionTypes.CREATE_CLIENT_SUCCESS,
    msg,
  };
};

export const ClearCreateClientMsg = () => {
  return {
    type: actionTypes.CLEAR_SUCCESS_MSG,
  };
};

export const createClient = (data, callBack) => {
  return (dispatch) => {
    // console.log(data);
    dispatch(createClientStart());
    axios
      .post(`/users/signup`, data)
      .then((res) => {
        console.log(res.data);
        dispatch(createClientSuccess(res.data.messgae));
        callBack();
      })
      .catch((err) => {
        console.log(err);
        // console.log(err.response);
        if (err.response) {
          dispatch(createClientFail(err.response.data.message));
        } else {
          dispatch(createClientFail("Something went wrong"));
        }
      });
  };
};

// delete client
export const deleteClientSuccess = (clientId) => {
  return {
    type: actionTypes.DELETE_CLIENT_SUCCESS,
    clientId,
  };
};
